import {
  GET_PROCESS_EXPORT_CSV_FILE,
  GET_PROCESS_IMPORT_CSV_FILE,
} from "./types";

export default {
  [GET_PROCESS_EXPORT_CSV_FILE]: (state) => state.exportCsv,
  [GET_PROCESS_IMPORT_CSV_FILE]: (state) => state.importCsv,
};
